<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="bg-dark" >
                <template #default>   <m-section-6 v-bind='{...{"text1":"\u0627\u0646\u0648\u0627\u0639 \u0645\u062d\u0627\u0641\u0638 \u062a\u0633\u0644\u0627\u0627\u0644\u06a9\u062a\u0631\u06cc\u06a9","text2":"\u0645\u062d\u0627\u0641\u0638 \u0647\u0627\u06cc \u0645\u06cc\u06a9\u0631\u0648\u067e\u0631\u0648\u0633\u0633\u0648\u0631\u06cc","text3":"\u062a\u06a9 \u0641\u0627\u0632 \u0648 \u0633\u0647 \u0641\u0627\u0632","text4":"\u0645\u062d\u0627\u0641\u0638\u062a 100\u062f\u0631\u0635\u062f\u06cc","text5":"\u0627\u0637\u0644\u0627\u0639\u0627\u062a \u0628\u06cc\u0634\u062a\u0631 "},...{}}' :style='""' class="" ></m-section-6><m-div v-bind='{...{},...{}}' :style='"background:#F1F1F9;\n\n\n\n\nbackground-image: url(\"https:\/\/api.teslaelectric.ir\/storage\/contents\/line.png\");\nbackground-repeat: no-repeat;\nbackground-size: cover;"' class="container-fluid rounded" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row " >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="col-12 text-center pt-4 h2" >
                <template #default>محافظ ها   </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='""' class="text-center container mt-3" >
                <template #default>   </template>
                </m-p><m-product-slider-2 v-bind='{...{"title":"","productCategories":["\u0645\u062d\u0627\u0641\u0638"],"productBrands":null,"waitForCategory":true,"waitForBrand":false,"categoryColumn":"slug","brandColumn":"slug","productCardLink":true,"productCardLinkTarget":"_self","activeLatestFilter":false,"activeCategoryFilter":false,"productCardName":"mProductCard922","showKeywords":false,"showDefaultSlideItem":false,"swiperPerViewSM":2,"swiperPerViewMD":3,"swiperPerViewLG":4,"autoPlay":false,"autoPlayDuration":1000},...{}}' :style='""' class="col-12 py-3" >
                <template #default>   </template>
                </m-product-slider-2><m-a v-bind='{...{"href":"{\"name\":\"m\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="col-12 text-center" >
                <template #default>   </template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row text-center" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="col-12 my-3" >
                <template #default>مشاوره و خرید    </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   </template>
                </m-p><m-button-301 v-bind='{...{"type":"button","href":null,"target":"_self"},...{}}' :style='""' class="col-6 mx-auto bg-primary mb-4" >
                <template #default>مشاهده   </template>
                </m-button-301></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mSection6 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section6'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mProductSlider2 from '@moeinmdn/miw-alpha-components/src/package/Product/ProductSlider/ProductSlider2'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mButton301 from '@moeinmdn/miw-alpha-components/src/package/Buttons/Button301';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mSection6,mH1,mP,mProductSlider2,mA,mButton301 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
